import PasswordField, {
  PasswordFieldProps,
} from '~/components/atoms/inputs/PasswordField';
import { withHookForm } from '~/decorators/withHookForm';

const HookFormPassword = withHookForm<PasswordFieldProps>(PasswordField);

export default HookFormPassword;
